import React from "react";
import { invokeGetUnreadMessages } from "./AwsInvoke";

export const UnreadMessages = async (globalAdminUserId) => {

    var results = await invokeGetUnreadMessages(globalAdminUserId);

    var unReadMessages = false;
    var unReadMessageIdsArray: [];

    if(results.length > 0) {
        var msg_array = [];
        for(var key in results) {
            var message_id = results[key].message_id;

            msg_array.push(message_id);
            //console.log("unreadMessages() results: " + message_id);
        }

        unReadMessages = true;
        unReadMessageIdsArray = msg_array;
    }

    var tmp_obj = {};
    tmp_obj.unReadMessages        = unReadMessages;
    tmp_obj.unReadMessageIdsArray = unReadMessageIdsArray;

    return tmp_obj;
}



// WEBPACK FOOTER //
// ./src/utils/UnreadMessages.js